import e from "../../utils/classNames.js";
import t from "./ApplicationLayoutHeader.js";
import n from "./ApplicationLayoutSidebar.js";
import r from "./ApplicationLayoutContext.js";
import i from "./ApplicationLayoutBody.js";
import { initDocumentBootstrapping as a } from "../../utils/init/initDocumentBootstrapping.js";
import { forwardRef as o } from "react";
import { jsx as s } from "react/jsx-runtime";
//#region src/components/applicationLayout/ApplicationLayout.tsx
a();
var c = o((t, n) => {
	let { behavior: i = "application", className: a, layoutRef: o, children: c, ...l } = t, u = e("ApplicationLayout", `behavior-${i}`, a);
	return /* @__PURE__ */ s(r.Provider, {
		value: i,
		children: /* @__PURE__ */ s("div", {
			...l,
			ref: n || o,
			className: u,
			children: c
		})
	});
});
c.Header = t, c.Sidebar = n, c.Body = i;
//#endregion
export { c as default };

//# sourceMappingURL=ApplicationLayout.js.map